<template>
  <div class="result-list-wrap">
    <div class="resultContent">
      <div class="resultTop">
        <div class="resultName"
             :title="title">{{ title }}</div>
        <div class="resultTag">
          <a-tag :color="colorChange(detailObj.last_legal_status_stat)">{{
            detailObj.last_legal_status_stat
          }}</a-tag>
          <a-tag :color="colorChange(detailObj.patent_status_stat)">{{
            detailObj.patent_status_stat
          }}</a-tag>
        </div>
      </div>
      <div class="resultTabs">
        <a-tabs type="card"
                v-model='activeKey'>
          <a-tab-pane :key="item.key"
                      :tab="item.tab"
                      v-for="item in tabList"
                      :disabled="item.disabled">
            <component :is="item.component"
                       :detailObj="detailObj"
                       :fileList="fileList"
                       class="detailMian"
                       ref="detail"></component>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Power from '../Power'
import Quote from '../Quote'
import InstructionBook from '../InstructionBook'
import InstructionFigure from '../InstructionFigure'
import BaseInfos from '../Infos'
import OriginalText from '../OriginText'
import { tabList } from '../config/index'
import { getFiles } from '@/api/resultSearch'

export default {
  props: {
    detailObj: Object,
  },
  data() {
    return {
      tabList,
      fileList: {},
      activeKey: 'baseInfos',
    }
  },
  computed: {
    title() {
      return `${this.detailObj.publication_number_sear}: ${this.detailObj.title}`
    },
  },
  watch: {
    detailObj(val) {
      if (val) {
        this.tabList.forEach((item) => {
          if (item.tab === '权利要求') {
            if (val.claims) {
              this.$set(item, 'disabled', false)
            } else {
              this.$set(item, 'disabled', true)
            }
          }
          if (item.tab === '说明书') {
            if (val.description) {
              this.$set(item, 'disabled', false)
            } else {
              this.$set(item, 'disabled', true)
            }
          }
        })
        this.getFiles(val)
      }
    },
  },
  components: {
    Power,
    Quote,
    InstructionBook,
    BaseInfos,
    OriginalText,
    InstructionFigure,
  },
  mounted() {
    this.$bus.$on('reductionChange', () => {
      this.activeKey = 'baseInfos'
      this.$refs.detail[0].$el.scrollTop = 0
    })
  },
  methods: {
    colorChange(val) {
      let bgColor = ''
      switch (val) {
        case '申请':
          bgColor = '#4769e5'
          break
        case '复查':
        case '审查':
          bgColor = '#4769e5'
          break
        case '变更':
        case '待转化':
        case '转让':
        case '许可':
        case '质押':
        case '复审':
        case '更正':
          bgColor = '#feb64d'
          break
        // 以上为法律状态
        case '有效':
          bgColor = '#13bfa3'
          break
        case '失效':
        case '失效或无效':
          bgColor = '#adafb8'
          break
        case '审查中':
          bgColor = '#f08330'
          break
        case '授权':
          bgColor = '#5c92ff'
          break
        case '到期':
        case '欠费':
        case '撤回':
        case '放弃':
        case '驳回':
        case '无效':
        case '撤销':
        case '中止':
          bgColor = '#8573f0'
          break
        default:
          break
      }
      return bgColor
    },
    getFiles(val) {
      const params = {
        fileType: 4,
        internal: false,
        publicNums: [],
        oss: true,
      }
      params.publicNums.push(val.publication_number_sear)
      getFiles(params).then((res) => {
        // eslint-disable-next-line prefer-destructuring
        if (res.code === 200) {
          const fileArr = JSON.parse(res.data)
          // eslint-disable-next-line prefer-destructuring
          this.fileList = fileArr[0]
          // eslint-disable-next-line prefer-destructuring
          // this.fileList = fileList[0]
          if (fileArr.length > 0) {
            this.tabList.forEach((item) => {
              if (item.tab === '说明书附图') {
                if (this.fileList.smsFile && this.fileList.smsFile.length > 0) {
                  this.$set(item, 'disabled', false)
                } else {
                  this.$set(item, 'disabled', true)
                }
              }
              if (item.tab === '专利原文') {
                if (this.fileList.pdfFile && this.fileList.pdfFile.length > 0) {
                  this.$set(item, 'disabled', false)
                } else {
                  this.$set(item, 'disabled', true)
                }
              }
            })
          }
        }
      })
    },
  },
  destroyed() {
    this.$bus.$off('reductionChange')
  },
}
</script>
